import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";

import { getSavedLanguage, setLanguage } from "./helpers/LanguageHelper";

import "./localization/i18n.ts";
import { Provider } from "react-redux";
import { store } from "./store/Store";
import { COLORS } from "./utils/Colors";

setLanguage(getSavedLanguage());

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const theme = extendTheme({
  colors: {
    primary: {
      500: COLORS.Brand.Primary,
      600: COLORS.Brand.Primary,
      700: COLORS.Brand.Primary,
      800: COLORS.Brand.Primary,
      900: COLORS.Brand.Primary,
      1000: COLORS.Brand.Primary,
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: "primary",
      },
    },
  },
});

root.render(
  <ChakraProvider theme={theme}>
    <Provider store={store}>
      <App />
    </Provider>
  </ChakraProvider>,
);
reportWebVitals();
